import { render } from "./VirtualMailboxesUserManagerDialog.vue?vue&type=template&id=2a1b0db6"
import script from "./VirtualMailboxesUserManagerDialog.vue?vue&type=script&lang=ts"
export * from "./VirtualMailboxesUserManagerDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script